// 设置 rem 函数
export default function setRem() {
    let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    let htmlDom = document.getElementsByTagName('html')[0];
    let menu = 100;
    if(htmlWidth < 1000){
        htmlDom.style.fontSize = '10px'
    }else {
        htmlDom.style.fontSize = htmlWidth / menu + 'px';
    }


}
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem()
}
